import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ShrapnelAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number,
  globalHue: number,
  cam?: { x: number, y: number, scale: number },
  width?: number,
  height?: number
) => {
  const t = timeSeconds;
  const count = 40;

  // Optimization: Pre-calculate screen bounds in world space if needed
  let minX = -Infinity, maxX = Infinity, minY = -Infinity, maxY = Infinity;
  const usePartialOpt = config.enableFrustumCulling && config.partialRingBlastOptimization && cam && width && height;
  if (usePartialOpt) {
      const halfW = width / 2;
      const halfH = height / 2;
      const scale = cam.scale || 1;
      const margin = config.frustumCullingMargin || 100;
      minX = -halfW / scale - cam.x - margin;
      maxX = halfW / scale - cam.x + margin;
      minY = -halfH / scale - cam.y - margin;
      maxY = halfH / scale - cam.y + margin;
  }

  for (let i = 0; i < count; i++) {
    const a = (i / count) * Math.PI * 2;
    const r = getRadiusAtAngle(a, e, e.maxRadius);
    const bx = Math.cos(a) * r;
    const by = Math.sin(a) * r;
    const v = 400 + Math.random() * 600;
    const d = t * v;
    const gy = 1200 * t * t;
    
    const wx = e.pos.x + bx + Math.cos(a) * d;
    const wy = e.pos.y + by + Math.sin(a) * d + gy;

    if (usePartialOpt) {
        if (wx < minX || wx > maxX || wy < minY || wy > maxY) continue;
    }

    ctx.fillRect(wx, wy, 4, 4);
  }
};

registerBlastAnimation('SHRAPNEL', ShrapnelAnimation);
